import {
  PUBLISH_SOFTSKILLS_COURSE,
  PUBLISH_SOFTSKILLS_COURSE_SUCCESS,
  PUBLISH_SOFTSKILLS_COURSE_CLEAN,
  PUBLISH_SOFTSKILLS_COURSE_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  course: undefined,
}

const SoftskillCoursePublish = (state = initialState, action) => {
  switch (action.type) {
    case PUBLISH_SOFTSKILLS_COURSE:
      state = {
        ...state,
        loading: true,
      }
      break
    case PUBLISH_SOFTSKILLS_COURSE_SUCCESS:
      state = {
        ...state,
        course: action.payload.course,
        loading: false,
        done: true,
      }
      break
    case PUBLISH_SOFTSKILLS_COURSE_CLEAN:
      state = initialState
      break
    case PUBLISH_SOFTSKILLS_COURSE_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default SoftskillCoursePublish
